import axios from "@/plugins/axios";

let url = "/api/v1/me/gshop/purchases";

export default {
    gets(data){
        return axios.get(`${url}`, data).then(result => result.data);
    },
}
